import styled from 'styled-components'

function SvgToggleOpenIcon({ isOpen = false, ...props }) {
  return isOpen ? (
    <svg
      width={12}
      height={8}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.54883 7.43164C5.79492 7.67773 6.20508 7.67773 6.45117 7.43164L11.7832 2.12695C12.0293 1.85352 12.0293 1.44336 11.7832 1.19727L11.1543 0.568359C10.9082 0.322266 10.498 0.322266 10.2246 0.568359L6.01367 4.7793L1.77539 0.568359C1.50195 0.322266 1.0918 0.322266 0.845703 0.568359L0.216797 1.19727C-0.0292969 1.44336 -0.0292969 1.85352 0.216797 2.12695L5.54883 7.43164Z"
        fill="#8DA0A5"
      />
    </svg>
  ) : (
    <svg
      width={12}
      height={8}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.45117 0.568359C6.20508 0.322266 5.79492 0.322266 5.54883 0.568359L0.216797 5.87305C-0.0292969 6.14648 -0.0292969 6.55664 0.216797 6.80273L0.845703 7.43164C1.0918 7.67773 1.50195 7.67773 1.77539 7.43164L5.98633 3.2207L10.2246 7.43164C10.498 7.67773 10.9082 7.67773 11.1543 7.43164L11.7832 6.80273C12.0293 6.55664 12.0293 6.14648 11.7832 5.87305L6.45117 0.568359Z"
        fill="#8DA0A5"
      />
    </svg>
  )
}

export default styled(SvgToggleOpenIcon)``
